import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Grid from 'components/core/Grid';
import styled, { css } from 'styled-components';

export const SetupItem = styled(Grid)`
  border-top: 1px dashed #ccc;
  &:first-child {
    margin-top: ${props => props.theme.spacing(4)};
  }
  margin-top: ${props => props.theme.spacing(1)};
`;

export const FailedAttempt = styled(Grid)`
  & .MuiTypography-root {
    color: ${props => props.theme.palette.error.main};
  }
`;

export const LogoImage = styled(Grid)`
  height: ${props => props.theme.spacing(10)};
  display: flex;
  justify-content: center;
  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const UploadLogo = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  & input {
    display: none;
  }
`;

export const StyledDialogTitle = styled(({ ...rest }) => <DialogTitle {...rest} />)`
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};

  ${props =>
    props.hasClose
      ? css`
          & .MuiTypography-root {
            display: flex;
            justify-content: space-between;
            flex: 1;
          }
        `
      : null}
`;

export const StyledDialogContent = styled(DialogContent) <{
  $paddingVertical?: number;
  $paddingHorizontal?: number;
  $greyBackground?: boolean;
  $hasOverflowY?: boolean;
  $isReverseColumn?: boolean;
}>`
  overflow: inherit;
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.spacing(3)};
  padding-bottom: ${props => props.theme.spacing(3)};

  ${props => props.theme.breakpoints.down('sm')} {
    padding: ${props => props.theme.spacing(2)};
  }

  ${props =>
    props.$paddingHorizontal !== undefined
      ? css`
          padding-left: ${props.$paddingHorizontal}px !important;
          padding-right: ${props.$paddingHorizontal}px !important;
        `
      : null}
  ${props =>
    props.$paddingVertical !== undefined
      ? css`
          padding-top: ${props.$paddingVertical}px !important;
          padding-bottom: ${props.$paddingVertical}px !important;
        `
      : null}

${props =>
    props.$greyBackground
      ? css`
          background-color: ${props => props.theme.palette.grey[50]};
        `
      : null}
${props =>
    props.$isReverseColumn
      ? css`
          flex-direction: column-reverse !important;
        `
      : null}

`;

export const StyledDialogActions = styled(DialogActions)`
  display: flex;
  justify-content: space-between;
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
  padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(3)};
  & button {
    min-width: 6rem;
  }
`;

export const TitleGrid = styled(Grid)`
  border-top: 1px dashed ${props => props.theme.palette.grey[300]};
`;

export const CompareTitle = styled(Grid)`
  border-bottom: 1px dashed ${props => props.theme.palette.grey[300]};
  background-color: ${props => props.theme.palette.grey[50]};
  font-weight: 500;
`;

export const CompareItem = styled(Grid)`
  background-color: ${props => props.theme.palette.grey[50]};
  font-weight: 500;
`;

export const SuccessGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  & svg {
    color: ${props => props.theme.palette.success.main};
    font-size: ${props => props.theme.spacing(10)};
  }
`;

export const WarningGrid = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
  & svg {
    color: ${props => props.theme.palette.warning.main};
    font-size: ${props => props.theme.spacing(10)};
  }
`;
